import { createContext, useContext } from 'react';

export const CompetitionContext = createContext({
    competitionName: '',
    currentSettingsId: null,
    currentYear: null,
    ReDrawAvailable: false,
    RunDrawAvailable: false,
    publicPagesLocked: false,
    refreshCompetition: async () => {}
});

export const useCompetition = () => useContext(CompetitionContext);
